import { render, staticRenderFns } from "./StepTabPayment.vue?vue&type=template&id=276861a1&scoped=true"
import script from "./StepTabPayment.vue?vue&type=script&lang=js"
export * from "./StepTabPayment.vue?vue&type=script&lang=js"
import style0 from "./StepTabPayment.vue?vue&type=style&index=0&id=276861a1&prod&scoped=true&lang=css"
import style1 from "./StepTabPayment.vue?vue&type=style&index=1&id=276861a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276861a1",
  null
  
)

export default component.exports